import React, { useState } from 'react';
export const useSwitch = (initialState = false) => {
    const [open, setOpen] = useState(initialState);
    const onOpen = React.useCallback(() => setOpen(true), []);
    const onClose = React.useCallback(() => setOpen(false), []);
    const toggle = React.useCallback(() => setOpen((prev) => !prev), []);
    return [open, onOpen, onClose, toggle];
};
